"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalStorage = exports.useGlobalState = void 0;
var useGlobalState_1 = require("./useGlobalState");
Object.defineProperty(exports, "useGlobalState", { enumerable: true, get: function () { return __importDefault(useGlobalState_1).default; } });
var useLocalStorage_1 = require("./useLocalStorage");
Object.defineProperty(exports, "useLocalStorage", { enumerable: true, get: function () { return __importDefault(useLocalStorage_1).default; } });
//# sourceMappingURL=index.js.map